import { __assign } from 'tslib';
import React__default from 'react';
import { CardActionArea, CardMedia, LinearProgress, Typography, Fade, Grid, Box, CircularProgress } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import DefaultIcon from '../../DefaultIcon/index.js';
import KMosaicElementNoBackground from '../KMosaicElementNoBackground/index.js';
import { KMosaicElementSize } from './index.props.js';
import StyledKMosaicElement, { classes } from './index.styled.js';

var SubTitle = function (_a) {
    var element = _a.element, _b = _a.KIcon, KIcon = _b === void 0 ? DefaultIcon : _b;
    var t = useTranslation("refront-components").t;
    if (element.hasChildren) {
        return (React__default.createElement(Box, { className: classes.subTitle },
            React__default.createElement(KIcon, { className: "".concat(classes.subTitleIcon, " fa-solid fa-folder") }),
            React__default.createElement(Typography, { className: classes.subTitleText, variant: "button" }, t("components.mosaic.folder-count.label", {
                count: element.subFolderCount
            }))));
    }
    return (React__default.createElement(Box, { className: classes.subTitle },
        !element.partialLoading && (React__default.createElement(KIcon, { className: "".concat(classes.subTitleIcon, " fa-regular fa-arrow-right") })),
        element.partialLoading && React__default.createElement(CircularProgress, { className: classes.partialLoading, size: 24 }),
        React__default.createElement(Typography, { className: classes.subTitleText, variant: "button" },
            !element.partialLoading && t("components.mosaic.asset-link.label"),
            element.partialLoading && t("components.mosaic.loading-folder.label"))));
};
var KMosaicElement = function (_a) {
    var _b;
    var _c, _d;
    var element = _a.element, elementSize = _a.elementSize, className = _a.className, onElementClick = _a.onElementClick, selected = _a.selected, _e = _a.component, component = _e === void 0 ? "li" : _e, _f = _a.grid, grid = _f === void 0 ? true : _f, loading = _a.loading, id = _a.id, imageComponent = _a.imageComponent, ComponentNextLink = _a.ComponentNextLink, borderRadius = _a.borderRadius, labelCustom = _a.labelCustom, maxHeaderHeight = _a.maxHeaderHeight, KIcon = _a.KIcon;
    var previewUrl = !!imageComponent && (imageComponent === null || imageComponent === void 0 ? void 0 : imageComponent.active) ? undefined : element.previewUrl;
    var contentCard = (React__default.createElement(CardActionArea, { onClick: function () { return onElementClick(element); }, className: classes.action },
        React__default.createElement(CardMedia, { onContextMenu: function (e) { return e.preventDefault(); }, className: classes.media, title: element.title },
            loading && React__default.createElement(LinearProgress, { className: classes.loader }),
            previewUrl && (React__default.createElement("img", { src: previewUrl, alt: (_c = element.title) !== null && _c !== void 0 ? _c : "", style: { width: "100%", height: "100%", objectFit: "cover" } })),
            !!imageComponent && (imageComponent === null || imageComponent === void 0 ? void 0 : imageComponent.active) && imageComponent.component(element.previewUrl),
            !element.previewUrl && React__default.createElement(KMosaicElementNoBackground, { title: (_d = element.title) !== null && _d !== void 0 ? _d : "" }),
            !!element.title && (React__default.createElement("header", { className: classes.header },
                React__default.createElement(Typography, { variant: "h6", component: "div", className: clsx("KMosaicElement-title", classes.elementTitle) }, element.title),
                element.showSubTitle && React__default.createElement(SubTitle, { element: element, KIcon: KIcon }))))));
    var content = (React__default.createElement(StyledKMosaicElement, { className: clsx("KMosaicElement-Card", classes.card), component: "article", role: "article", id: element.title, "data-testid": element.hasChildren ? "displayFolderSubFolders" : "displayFolderContent", labelCustom: labelCustom, borderRadius: borderRadius, maxHeaderHeight: maxHeaderHeight },
        ComponentNextLink && (React__default.createElement(ComponentNextLink, { href: element.href, target: element.targetBlank ? "_blank" : "_self" }, contentCard)),
        !ComponentNextLink && contentCard,
        React__default.createElement(Fade, { "in": selected && element.hasChildren },
            React__default.createElement("span", { "aria-hidden": true, className: classes.activeArrow }))));
    var mainSx = __assign({ position: "relative", "& *": {
            boxSizing: "border-box"
        } }, (selected && (_b = {},
        _b["& .".concat(classes.card)] = {
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)"
        },
        _b)));
    if (grid) {
        return (React__default.createElement(Grid, __assign({ id: id, item: true, "data-element-id": element.id }, getBreakPoint(elementSize || KMosaicElementSize.M), { className: clsx("KMosaicElement", selected && "KMosaicElement-selected", className), component: component, sx: mainSx }), content));
    }
    return (React__default.createElement(Box, { id: id, "data-element-id": element.id, className: clsx("KMosaicElement", selected && "KMosaicElement-selected", className), component: component, sx: mainSx }, content));
};
function getBreakPoint(elementSize) {
    switch (elementSize) {
        case KMosaicElementSize.S: {
            return {
                xs: 5,
                sm: 4,
                md: 2
            };
        }
        case KMosaicElementSize.M: {
            return {
                xs: 6,
                sm: 4,
                md: 3
            };
        }
        case KMosaicElementSize.L: {
            return {
                xs: 8,
                sm: 5,
                md: 4
            };
        }
        case KMosaicElementSize.XL: {
            return {
                xs: 12,
                sm: 6,
                md: 6
            };
        }
        default: {
            return {};
        }
    }
}

export { KMosaicElement, KMosaicElement as default };
//# sourceMappingURL=index.js.map
